import {post, get} from '@/common/utils/Http';

export default {
  retrySend: post('/task/retrySend'),
  countSent: post('/task/countSent'),
  getNews: post('/mass/getNews'),
  getImages: post('/mass/getImages'),
  getCoupons: post('/mass/getCoupons'),
  getCouponByCard: post('/mass/getCouponByCard'),
  previewMsg: post('/mass/previewMsg'),
  getExpectCount: post('/broadcast/getExpectCount'),
  getHelperByRights: post('/helper/getHelperByRights'),
  verifyCode: post('/helper/verifyCode'),
  sendVerifyCode: post('/helper/sendVerifyCode'),
  createAuth: post('/helper/createAuth'),
  getAdmin: post('/helper/getAdmin'),
  monitorAuth: post('/helper/monitorAuth'),
  refreshAuth: post('/helper/refreshAuth'),
  confirmAuth: post('/helper/confirmAuth'),
  confirmReplaceAuth: post('/helper/confirmReplaceAuth'),
  removeAuth: post('/helper/removeAuth'),
  sendHelperRightApplyTpl: post('/helper/sendHelperRightApplyTpl'),
  sendReplaceSuperUserTpl: post('/helper/sendReplaceSuperUserTpl'),
  setSuper: post('/helper/setSuper'),
  getAllTask: post('/task/getAll'),
  getTaskByTypes: post('/task/getByTypes'),
  cancelTask: post('/task/cancelTask'),
  getMassNewsStat: post('/task/getMassNewsStat'),
  deleteMsg: post('/mass/deleteMsg'),
  getSubTpls: post('wxsub/getTpls'),
  getSubCounts: post('wxsub/getSubCounts'),
  previewSubTpl: post('wxsub/preview'),
  deleteSubTpl: post('wxsub/delete'),
};
